export const iconFontAwesomeLogisticsChartSimple = (
	<i className="fa-solid fa-chart-simple"></i>
);
